import React from 'react'

function TenderTextKKSG() {
  return (
    <embed src="\pdfs\EAT2.2.2_KKS-4-GK_Contact_cooling_ceiling_system_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextKKSG